module.exports = __webpack_public_path__ + "static/media/chat-bot.d83d2058.svg";